import { IDomainStore } from '../interface/IDomainStore';
import { Store } from './Store';

export abstract class DomainStore extends Store implements IDomainStore {}
